
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["archive",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.16 87.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"data-name":"Capa 1"}},[_c('path',{attrs:{"d":"M34.44 15.65h3.37v3.37h-3.37zM40.7 15.65h22.15v3.37H40.7zM34.44 21.91h3.37v3.37h-3.37zM40.7 21.91h22.15v3.37H40.7zM34.44 28.18h3.37v3.37h-3.37zM40.7 28.18h22.15v3.37H40.7zM34.44 9.39h3.37v3.37h-3.37zM40.7 9.39h22.15v3.37H40.7z"}}),_c('path',{attrs:{"d":"M81.64 37.57V6.26h-9.39V0H26L9.39 16.64v8.41H0V87.9h94.16V37.57zM15.15 15.65l9.9-9.9v9.9zM28.42 19V3.37h40.46v34.2H34l-6.23-12.52h-15V19zm62.37 21.94v43.59H3.37V28.42h22.32l6.23 12.45v.07zm-18.54-3.37V9.63h6v27.94z"}})])])])
          )
        }
      }
    